import { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, IconButton, Checkbox } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useNavigate, useParams } from "react-router-dom";
import { deleteCommentEntities, fetchEntityById } from "../../../apis/apiService";
import Loader from "../../../components/common/Loader";
import CommonDeleteDialog from "../../../components/common/CommonDelete";
// import DeactivateUser from "../../../components/common/UserDeactivate";

const UserTask = ({ ProjectID }) => {
  const { id } = useParams();
  const [rows, setRows] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const navigate = useNavigate();
  const [paginationModel, setPaginationModal] = useState({
    page: 0,
    pageSize: 10,
  });
  const [loading, setLoading] = useState(false);
  const { id: user_id } = useParams();
  // //console.log()("user_id :", user_id);

  const columns = [
    {
      field: "actions",
      headerName: "Action",
      width: 120,
      renderCell: (params) => (
        <Box display="flex" alignItems="center">
          {params.row.isProject || params.row.isTaskList ? (
            <IconButton onClick={() => toggleExpandRow(params.row.id)}>
              {expandedRows[params.row.id] ? (
                <ExpandLessIcon />
              ) : (
                <ExpandMoreIcon />
              )}
            </IconButton>
          ) : null}
          {params.row.isTask ? <Checkbox /> : null}
        </Box>
      ),
    },
    { field: "id", headerName: "ID", width: 100 },
    { field: "name", headerName: "Name", width: 250 },
    { field: "owner", headerName: "Owner", width: 150 },
    {
      field: "status",
      headerName: "Status",
      width: 180,
      renderCell: (params) => {
        const color = params.row.status_colour;
        const name = params.value;
        return <p style={{ color: color }}>{name}</p>;
      },
    },
    { field: "startDate", headerName: "Start Date", width: 150 },
    { field: "dueDate", headerName: "Due Date", width: 150 },
    { field: "duration", headerName: "Duration", width: 150 },
    {
      field: "priority",
      headerName: "Priority",
      width: 120,
      renderCell: (params) => {
        const color = params.row.priority_colour;
        const name = params.value;
        return <p style={{ color: color }}>{name}</p>;
      },
    },
  ];

  const fetchTasks = async () => {
    setLoading(true);
    try {
      const response = await fetchEntityById("getTaskDetails", id);
      if (response?.data) {
        setRows(transformResponse(response.data));
        // //console.log()("response_data: ", response.data);
      }
    } catch (error) {
      console.error("Error fetching tasks:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTasks();
  }, []);
  const toggleExpandRow = (rowId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId], // Toggle expansion for the clicked row
    }));
  };

  const getFlattenedRows = () => {
    const flattenedRows = [];

    rows.forEach((project) => {
      flattenedRows.push(project);

      if (expandedRows[project.id] && project.taskLists) {
        project.taskLists.forEach((taskList) => {
          flattenedRows.push(taskList);

          if (expandedRows[taskList.id] && taskList.tasks) {
            taskList.tasks.forEach((task) => flattenedRows.push(task));
          }
        });
      }
    });

    return flattenedRows;
  };

  const transformResponse = (data) => {
    if (!Array.isArray(data)) return [];

    return data.map(({ project, task_lists }) => {
      const projectRow = {
        id: `P-ID${project.project_id}`,
        name: project.title,
        owner: `${project.owner_name}`,
        startDate: new Date(project.start_date).toLocaleDateString(),
        dueDate: new Date(project.end_date).toLocaleDateString(),
        status: project.current_status_name || "N/A",
        status_colour: project.status_status_colour || " ",
        priority_colour: project.status_priority_colour || " ",
        isProject: true,
        taskLists: task_lists.map(({ task_list, tasks }) => {
          const taskListRow = {
            id: `TL-ID${task_list.task_list_id}`, // Fixed task list ID reference
            name: task_list.task_list_name,
            owner: `${task_list.owner || " "}`,
            startDate: task_list.added_at
              ? new Date(task_list.added_at).toLocaleDateString()
              : "N/A",
            isTaskList: true,
            parentId: `P-ID${project.project_id}`, // Fixed parent reference
            tasks: (task_list.tasks || tasks || []).map((task) => ({
              id: `T-${task.task_id}`,
              name: task.title,
              owner: task.owner,
              status: task.current_status_name || "N/A",
              startDate: task.start_date
                ? new Date(task.start_date).toLocaleDateString()
                : "N/A",
              dueDate: task.end_date
                ? new Date(task.end_date).toLocaleDateString()
                : "N/A",
              duration: task.estimated_hours
                ? `${task.estimated_hours} hrs`
                : "N/A",
              priority: task.priority_name || "Low",
              status_colour: task.status_colour,
              priority_colour: task.priority_colour,
              isTask: true,
              parentId: `TL-ID${task.task_list_id}`, // Fixed parent reference
            })),
          };
          return taskListRow;
        }),
      };
      return projectRow;
    });
  };

  const deactivateUser = async () => {
    await deleteCommentEntities("user/deactivate", user_id);
    // name user
    // refetch fetchTasks
  };
  return (
    <Box style={{ width: "100%" }}>
      {/* <div className="d-flex align-items-center my-3 justify-content-end gap-2 ">
        <DeactivateUser
          url="user/deactivate"
          id={user_id}
          name="User"
          refetchList={fetchTasks}
        />
      </div> */}
      {loading ? (
        <Loader />
      ) : (
        <DataGrid
          rows={getFlattenedRows()}
          columns={columns}
          getRowId={(row) => row.id}
          pagination
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModal}
          pageSizeOptions={[10, 20, 30, 40]}
          autoHeight
        />
      )}
    </Box>
  );
};

export default UserTask;
